import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../services/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';

const REDIRECTS = { tutor: '/tutor', student: '/student', admin: '/admin' };

const Login = () => {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [form, setForm] = useState({ email: '', password: '', role: 'tutor' });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await loginUser(form);
      login(data.token, data.user);
      toast.success(`Welcome back, ${data.user.name}!`);
      navigate(REDIRECTS[data.user.role] || '/');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally { setLoading(false); }
  };

  const roles = [
    { id: 'tutor', label: '👨‍🏫 Tutor' },
    { id: 'student', label: '📚 Student' },
    { id: 'admin', label: '🛡️ Admin' },
  ];

  return (
    <div style={{ minHeight: '90vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', background: 'var(--lighter)' }}>
      <div style={{ width: '100%', maxWidth: '440px' }}>
        {/* Card */}
        <div style={{ background: 'white', borderRadius: '28px', padding: '40px', boxShadow: 'var(--shadow-lg)' }}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: '26px' }}>🎓</div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '26px', fontWeight: 800, marginBottom: '4px' }}>Welcome back</h2>
            <p style={{ color: 'var(--gray)', fontSize: '14px' }}>Sign in to your account</p>
          </div>

          {/* Role selector */}
          <div style={{ display: 'flex', background: 'var(--light)', borderRadius: '14px', padding: '4px', marginBottom: '24px', gap: '4px' }}>
            {roles.map(r => (
              <button key={r.id} type="button" onClick={() => setForm(f => ({ ...f, role: r.id }))}
                style={{ flex: 1, padding: '10px 6px', border: 'none', borderRadius: '11px', cursor: 'pointer', fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 600, transition: 'all 0.2s',
                  background: form.role === r.id ? 'white' : 'transparent',
                  color: form.role === r.id ? 'var(--primary)' : 'var(--gray)',
                  boxShadow: form.role === r.id ? 'var(--shadow-sm)' : 'none',
                }}>{r.label}</button>
            ))}
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: 'var(--dark)', marginBottom: '6px' }}>Email Address</label>
              <div style={{ position: 'relative' }}>
                <FiMail style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)', fontSize: '16px' }} />
                <input type="email" required value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                  placeholder="you@email.com"
                  style={{ width: '100%', padding: '12px 14px 12px 42px', border: '1.5px solid var(--border)', borderRadius: '12px', fontSize: '14px', fontFamily: 'var(--font-body)', transition: 'border-color 0.2s' }} />
              </div>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: 'var(--dark)', marginBottom: '6px' }}>Password</label>
              <div style={{ position: 'relative' }}>
                <FiLock style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)', fontSize: '16px' }} />
                <input type={showPass ? 'text' : 'password'} required value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                  placeholder="Your password"
                  style={{ width: '100%', padding: '12px 42px 12px 42px', border: '1.5px solid var(--border)', borderRadius: '12px', fontSize: '14px', fontFamily: 'var(--font-body)', transition: 'border-color 0.2s' }} />
                <button type="button" onClick={() => setShowPass(!showPass)}
                  style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--gray)' }}>
                  {showPass ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} className="btn-primary-custom" style={{ width: '100%', padding: '14px' }}>
              {loading ? <><span className="spinner-border spinner-border-sm me-2" />Signing in...</> : 'Sign In →'}
            </button>
          </form>

          <p style={{ textAlign: 'center', fontSize: '13px', color: 'var(--gray)', marginTop: '20px', marginBottom: 0 }}>
            Don't have an account? <Link to="/register" style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>Register here</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
